"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateSource = void 0;
var AffiliateSource;
(function (AffiliateSource) {
    AffiliateSource["Trackdesk"] = "Trackdesk";
    AffiliateSource["Syndic"] = "Syndic";
})(AffiliateSource || (exports.AffiliateSource = AffiliateSource = {}));
//# sourceMappingURL=AffiliateSource.js.map